/* eslint-disable implicit-arrow-linebreak */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AlertAdapter } from 'pg-ui-library';
import { IBenefitFixedPrice } from 'src/interfaces';
import BenefitsService from 'src/services/benefits.service';

export const usePostBenefitFixedPrice = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation((data: IBenefitFixedPrice) => BenefitsService.postBenefitFixedPrice(data), {
    onSuccess: () => {
      AlertAdapter('Fixed price added successfully', 'success');
      queryClient.invalidateQueries({ queryKey: ['benefits/prices'] });
    },
    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });
  return mutation;
};
